import type { ReactNode } from 'react';

export function MaintenancePage(): ReactNode {
    return (
        <div className="fixed inset-0 z-[9999] bg-[#F8FAFC] flex items-center justify-center p-6">
            <div className="max-w-md w-full text-center">
                <img src="/logo.png" alt="BTPal" className="w-14 h-14 rounded-xl mx-auto mb-6 animate-pulse" />
                <h1 className="text-2xl font-semibold text-[#0F172A] mb-3">
                    Service temporairement indisponible
                </h1>
                <p className="text-[#64748B] mb-2">
                    BTPal est en cours de maintenance. Nous revenons très vite.
                </p>
                <p className="text-sm text-[#94A3B8]">
                    Cette page se rafraîchira automatiquement dès que le service sera rétabli.
                </p>
                <div className="mt-8 text-xs text-[#94A3B8]">
                    Un souci persiste ? Contactez-nous à{' '}
                    <a href="mailto:contact@btpal.fr" className="text-[#2563EB] hover:underline">
                        contact@btpal.fr
                    </a>
                </div>
            </div>
        </div>
    );
}
